import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Noticias } from '../_model/Noticias';
import { MatrixPipe } from '../_pipes/matrix.pipe';
import { NewsService } from '../_services/news.service';

@Component({
    selector: 'app-singlenews',
    templateUrl: './singlenews.component.html',
    styleUrls: ['./singlenews.component.less'],
    standalone: false
})
export class SinglenewsComponent implements OnInit {

  constructor(private news: NewsService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.id = Number.parseInt(params['id']);
    });
  }

  id: number = 0;
  item: Noticias = new Noticias(); 
  apiUrl: string = environment.apiUrl;
  media: string[][] = [];
  master: string = "";
  toMatrix: MatrixPipe = new MatrixPipe();

  ngOnInit() {
    this.news.get(this.id).subscribe((data: Noticias) =>{
      this.item = new Noticias(data);
      var arr = this.item.media.split(";");
      this.master = arr[0];
      arr.splice(0,1);
      arr = arr.filter(x => x != "");
      this.media = this.toMatrix.transform(arr, 4);
    });
  }

  swapImage(i: number, j: number) {
    var temp = this.media[i][j];
    this.media[i][j] = this.master;
    this.master = temp;
  }

}
